import { checkboxClasses, SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { useContext } from 'react';

import Checkbox from '~components/Checkbox/Checkbox';
import { JobInvoicing } from '~hooks/useJob/models';
import FilesPageContext from '~pages/Approvals/Files/FilesPageContext';

interface CheckboxColumnProps {
  job: JobInvoicing;
  sx?: SxProps<Theme>;
}

export default function CheckboxColumn({ job, sx }: CheckboxColumnProps) {
  const { getJobCheckedState, toggleJobCheck } = useContext(FilesPageContext);

  const isChecked = getJobCheckedState(job);

  return (
    <Box sx={sx}>
      <Checkbox
        isChecked={isChecked}
        onChange={() => toggleJobCheck(job)}
        sx={{ [`&.${checkboxClasses.root}`]: { mt: '-10px' } }}
      />
    </Box>
  );
}
